import { css } from '@emotion/react'
import { TraceKeyResponseTypeEnum } from '@ulysses-inc/harami_api_client'
import type { GetProps } from 'antd'
import { Flex, Typography } from 'antd'
import { addDays, subDays } from 'date-fns'
import { DateFnsDatePicker } from 'src/components/datepicker/DateFnsDatePicker'
import { TraceKeyConditionFilter } from 'src/features/reports/listBetaFilters/drawer/hooks/useTraceKeyFilter'

const { RangePicker } = DateFnsDatePicker
const { Text } = Typography
type RangePickerProps = GetProps<typeof RangePicker>

const disabledDate: RangePickerProps['disabledDate'] = (
  current: Date,
  { from },
) => {
  const DATE_RANGE_LIMIT_DAYS = 7
  if (from) {
    const maxDate = addDays(from, DATE_RANGE_LIMIT_DAYS)
    const minDate = subDays(from, DATE_RANGE_LIMIT_DAYS)
    return current <= minDate || current >= maxDate
  }
  return false
}
type DateTraceKeyFilter = Extract<
  TraceKeyConditionFilter,
  { responseType: TraceKeyResponseTypeEnum.Date }
>
type Props = {
  filter: DateTraceKeyFilter
  onChange: (newFilter: DateTraceKeyFilter) => void
  showError: boolean
}

export const DateTraceKeyFilter = ({ filter, onChange, showError }: Props) => {
  const hasError =
    !filter.datetime?.greaterThanOrEqual || !filter.datetime?.lessThan
  const shouldShowError = showError && hasError

  return (
    <Flex vertical gap={4}>
      <RangePicker
        value={
          filter.datetime?.greaterThanOrEqual && filter.datetime?.lessThan
            ? [filter.datetime.greaterThanOrEqual, filter.datetime.lessThan]
            : [null, null]
        }
        onChange={dates => {
          if (!dates || !dates[0] || !dates[1]) {
            // 両方入力されていない場合は条件をクリア
            onChange({
              ...filter,
              datetime: null,
            })
            return
          }

          // 両方入力された場合のみ条件を設定
          onChange({
            ...filter,
            datetime: {
              greaterThanOrEqual: dates[0],
              lessThan: dates[1],
            },
          })
        }}
        disabledDate={disabledDate}
        placeholder={['開始日', '終了日']}
        status={shouldShowError ? 'error' : undefined}
      />
      {shouldShowError && (
        <Text type="danger" css={styles.errorText}>
          検索キーの値を入力してください
        </Text>
      )}
    </Flex>
  )
}

const styles = {
  errorText: css`
    font-size: 12px;
  `,
}
